import React from 'react'
import { CheckboxIcon } from './checkbox-icon'
import { InstallerUploadForm } from './documents'
import {
  AgentDocResult,
  ChecklistItemStatus,
  ChecklistItemType,
  mdyyyy,
  getBadgeClass,
  getChecklistItemDate,
  getDisplayLabel,
  LoanFundingPhaseShared,
} from '@oneethos/shared'

const ChecklistDocItemUpload = ({ handleRowToggle, project, item, isExpanded, onProjectChange }) => {
  const status = LoanFundingPhaseShared.getLoanFundingChecklistItemStatus(item, project)
  const bankerComments = project[item.dataField]
  const { agentComments, agentResult } = LoanFundingPhaseShared.getDocStatusAndAgentResult(
    project.installerDocs, item.label
  ) || {}
  const isAgentAprroved = agentResult === AgentDocResult.Approve
  const date = status === ChecklistItemStatus.NeedsAction ? 
    null : mdyyyy(getChecklistItemDate(item, project))

  return (
    <>
      {!isExpanded && (
        <tr className='align-middle'>
          <td style={{ width: '30px' }}>
            <CheckboxIcon isCompleted={status === ChecklistItemStatus.Completed} checklistOwner={item.owner}/>
          </td>
          <td style={{ maxWidth: '300px' }}>
            <div className="fw-bold mb-1 pointer" onClick={handleRowToggle}>{getDisplayLabel(item.label)}</div>
            <div className={`text-muted small pointer ${isExpanded ? '' : 'd-block text-truncate'}`} onClick={handleRowToggle}>
              {item.description}
            </div>
            {(agentComments && !bankerComments) &&
              <div className={`small ${isAgentAprroved ? 'text-success' : 'text-danger'} ${isExpanded ? '' : 'd-block text-truncate'}`}>
                <b>AI Comments: </b>{agentComments}
              </div>
            }
            {bankerComments &&
              <div className={`small text-danger ${isExpanded ? '' : 'd-block text-truncate'}`}>
                <b>Funding Team Comments: </b>{project[item.dataField]}
              </div>
            }
          </td>
          <td className="text-center">{date}</td>
          <td className="text-center">
            <div className={`badge text-capitalize rounded-pill ${getBadgeClass(status)}`}>{status}</div>
          </td>
          <td className="text-capitalize text-center">{item.owner}</td>
        </tr>
      )}
      {isExpanded && item.type === ChecklistItemType.DocumentUpload && (
        <InstallerUploadForm
          checklistItems={[item]}
          project={project}
          onProjectChange={onProjectChange}
          limitToSlots={[item.label]}
          handleRowToggle={handleRowToggle}
          bankerComments={bankerComments}
          isCompleted={status === ChecklistItemStatus.Completed}
          dateField={date}
          status={status}
          checklistOwner={item.owner}
        />
      )}
    </>
  )
}

export default ChecklistDocItemUpload
